document.documentElement.classList.remove('no-js');

function tusSetColor(scope, color) {
  scope = scope || document;
  scope.querySelectorAll('.swatch').forEach(function (swatch) {
    swatch.classList.toggle('active', swatch.getAttribute('data-color') === color);
    swatch.setAttribute('aria-pressed', swatch.getAttribute('data-color') === color ? 'true' : 'false');
  });
  scope.querySelectorAll('.color-label').forEach(function (label) {
    label.textContent = color === 'white' ? 'White' : 'Black';
  });
  scope.querySelectorAll('.color-photo').forEach(function (image) {
    var whiteSrc = image.getAttribute('data-white');
    var blackSrc = image.getAttribute('data-black');
    if (whiteSrc && blackSrc && whiteSrc !== blackSrc) {
      image.src = color === 'black' ? blackSrc : whiteSrc;
      image.classList.remove('is-black');
    } else {
      image.classList.toggle('is-black', color === 'black');
    }
  });
}

document.addEventListener('click', function (event) {
  var swatch = event.target.closest('[data-tus-swatch]');
  if (swatch) tusSetColor(swatch.closest('.shopify-section') || document, swatch.dataset.color);
  var toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (panel) {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
});

function initCountdown(section) {
  section = section || document;
  section.querySelectorAll('[data-countdown]').forEach(function (root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var daysToRun = parseInt(root.dataset.days || '7', 10);
    var deadlineValue = root.dataset.deadline;
    var deadline = deadlineValue ? new Date(deadlineValue).getTime() : Date.now() + daysToRun * 86400000;
    function update() {
      var diff = Math.max(0, deadline - Date.now());
      var values = {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        mins: Math.floor((diff % 3600000) / 60000),
        secs: Math.floor((diff % 60000) / 1000)
      };
      Object.keys(values).forEach(function (key) {
        var el = root.querySelector('[data-' + key + ']');
        if (el) el.textContent = String(values[key]).padStart(2, '0');
      });
    }
    update();
    root._tusInterval = setInterval(update, 1000);
  });
}

document.addEventListener('DOMContentLoaded', function () { initCountdown(document); });
document.addEventListener('shopify:section:load', function (event) { initCountdown(event.target); });
